const short = require("short-uuid"); // https://www.npmjs.com/package/short-uuid

export default function contactUUID() {
  return `${Math.floor(Date.now() / 1000)}-${short.generate()}`;
}

// something like: "1701979213-73WakrfVbNJBaAmhQtEeDv"
